import React, { useRef } from 'react';
import './DoNotTranslateEditor.scss';
import { Column, Grid } from '../../../../FormComponents/Grid/Grid';
import { DoNotTranslate } from '../../../../../types/Glossary';
import Help from '../../../../Help/Help';

type Props = {
  data: DoNotTranslate[];
  setData: React.Dispatch<React.SetStateAction<DoNotTranslate[]>>;
  setIsDirty: React.Dispatch<React.SetStateAction<boolean>>;
};

export const DoNotTranslateEditor = (props: Props) => {
  const gridRef = useRef<HTMLDivElement>(null);

  const columns: Column<DoNotTranslate>[] = [
    { key: "phrase", label: "Word/Phrase", type: "text" },
    { key: "match", label: "Case Sensitive", type: "checkbox", width: "100px" }
  ];
   
  return (
    <>
      <div ref={gridRef} className="do-not-translate-editor">
        <p>Used to mark words or phrases that should remain unchanged during translation, such as proper nouns, brand names, acronyms, or technical terms.
        <Help
          title="🛑 Do Not Translate"
          text={`<br/><b>Purpose:</b> Used to mark words or phrases that should remain unchanged during translation.<br/><br/><b>Description:</b> This is useful for proper nouns, brand names, acronyms, technical terms, or any text that must stay exactly as written. Matching is case-insensitive and punctuation-safe.<br/><br/><b>Example:</b><br/>Phrase → AccessLoop<br/>With “Do Not Translate” enabled:<br/>"AccessLoop" → remains "AccessLoop"<br/>"accessloop!" → remains "accessloop!"<br/>"ACCESSLOOP" → remains "ACCESSLOOP"<br/><br/><b>General Notes:</b><br/>Only exact matches are protected — words that contain the phrase as part of another word are not affected.<br/>Punctuation such as . , ! ? ; : is preserved.<br/>Useful in conjunction with glossaries to ensure branding and technical terms are not accidentally translated.`}
          maxWidth='660px'
        /></p>
        <Grid<DoNotTranslate> 
          columns={columns}
          setIsDirty={props.setIsDirty}
          data={props.data}
          setData={props.setData}
          maxHeight={220} />
      </div>
    </>
  );
};
